import { createStore, applyMiddleware } from 'redux';
import ArtistsSearchReducer from '../reducers/ArtistsSearchReducer';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';

const configureStore = (railsProps) => (
  createStore(ArtistsSearchReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
